import type { ProformaInvoice } from "../../../Models.types";
import { Actions } from "./Actions";
import { Amount } from "./Amount";
import { AmountWithVat } from "./AmountWithVat";
import { Brand } from "./Brand";
import { Documents } from "./Documents";
import { DueDate } from "./DueDate";
import { IssueDate } from "./IssueDate";
import { PaidAt } from "./PaidAt";
import { ProformaNo } from "./ProformaNo";
import { Project } from "./Project";

export interface ColumnProps {
  row: ProformaInvoice;
}

export const Column = {
  Actions,
  Amount,
  AmountWithVat,
  Brand,
  DueDate,
  Documents,
  IssueDate,
  PaidAt,
  ProformaNo,
  Project,
};
